<template>
  <div class="md:w-[80%] mx-auto" v-if="faqItems">
    <div class="w-[80%] mx-auto">
      <h2
        class="text-primary-1 text-mobile-heading-2 md:text-heading-2 mb-[10px] text-center"
      >
        {{ t("discover.faqTitle") }}
      </h2>
      <p
        class="text-gray-1 text-mobile-paragraph-1 md:text-paragraph-1 mb-[30px] text-center"
      >
        {{ t("discover.faqDescription") }}
      </p>
    </div>
    <FaqListCard
      v-for="(item, i) in faqItems"
      :key="i"
      :question="item?.question"
      :answer="item?.answer"
      icon-type="plus"
      class="!bg-white border border-gray-4"
    />
  </div>
</template>

<script setup lang="ts">
import { type PropType } from "vue";

type IFaq = { question: string; answer: string };
defineProps({
  faqItems: { type: Array as PropType<IFaq[]>, required: true },
});

const { t } = useI18n();
</script>
<style lang="scss" scoped>
.dark-mode {
  h2,
  p {
    @apply text-title-color;
  }
}
</style>
